/**
@prop --ux-table-sort-active-color: color of the active sort arrow
@prop --ux-table-sort-inactive-color: color of the inactive sort arrow
@prop --ux-table-sort-inactive-opacity: opacity of the inactive sort arrow
 */
.ux-table-data-sort {
  align-items: center;
  cursor: pointer;
  display: inline-flex;

  &__icon {
    align-items: center;
    display: flex;
    fill: currentcolor;
    flex-direction: column;
    font-size: 14px;
    justify-content: center;
  }

  &[sorted-direction="asc"] {
    .ux-table-data-sort__icon .ux-icon__sort-up {
      fill: var(--ux-table-sort-active-color, currentColor);
    }

    .ux-table-data-sort__icon .ux-icon__sort-down {
      fill: var(--ux-table-sort-inactive-color, currentColor);
      opacity: var(--ux-table-sort-inactive-opacity, 0.3);
    }
  }

  &[sorted-direction="desc"] {
    .ux-table-data-sort__icon .ux-icon__sort-up {
      fill: var(--ux-table-sort-inactive-color, currentColor);
      opacity: var(--ux-table-sort-inactive-opacity, 0.3);
    }

    .ux-table-data-sort__icon .ux-icon__sort-down {
      fill: var(--ux-table-sort-active-color, currentColor);
    }
  }
}
